import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
} from "@mui/material";
import i18n from "i18next";
import { getCustomerOrderProfitabilityPlanLineScenarioTypeLabel } from "src/api/generated/erp/db/types/enums/customerOrderProfitabilityPlanLineScenarioType.ts";
import { CustomerOrderProfitabilityHistoryApi } from "src/api/generated/erp/sales/customerOrder/profitability/api/customerOrderProfitabilityHistoryApi.ts";
import { getCustomerOrderProfitabilityLineKeyLabel } from "src/api/generated/erp/sales/customerOrder/profitability/model/customerOrderProfitabilityLineKey.ts";
import { AsyncFetchRender } from "src/components/common/async/AsyncFetchRender.tsx";
import { VerticalBox } from "src/components/common/box/VerticalBox.tsx";
import { formatIsoString } from "src/utils/dayjsUtils.ts";

export interface CustomerOrderProfitabilityHistoryViewProps {
	customerOrderId: number;
}

export const CustomerOrderProfitabilityHistoryView = ({
	customerOrderId,
}: CustomerOrderProfitabilityHistoryViewProps) => {
	return (
		<AsyncFetchRender
			fetch={() => CustomerOrderProfitabilityHistoryApi.getHistory({ customerOrderId })}
			content={(events) => (
				<VerticalBox sx={{ flex: 1, minHeight: 0 }}>
					{events.length === 0 ?
						<Typography sx={{ padding: 2 }}>{i18n.t("no_data")}</Typography>
					:	<TableContainer sx={{ flex: 1 }}>
							<Table stickyHeader size="small">
								<TableHead>
									<TableRow>
										<TableCell>{i18n.t("date")}</TableCell>
										<TableCell>{i18n.t("scenario")}</TableCell>
										<TableCell>{i18n.t("row")}</TableCell>
										<TableCell>{i18n.t("modified_by")}</TableCell>
										<TableCell>{i18n.t("change_log")}</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{events.map((event) => (
										<TableRow key={event.objectModificationLogEventId}>
											<TableCell>{formatIsoString(event.modifiedAt, "L LT")}</TableCell>
											<TableCell>
												{getCustomerOrderProfitabilityPlanLineScenarioTypeLabel(event.scenarioType)}
											</TableCell>
											<TableCell>{getCustomerOrderProfitabilityLineKeyLabel(event.lineKey)}</TableCell>
											<TableCell>{event.modifiedByAppUserName}</TableCell>
											<TableCell sx={{ whiteSpace: "pre-wrap" }}>{event.modification}</TableCell>
										</TableRow>
									))}
								</TableBody>
							</Table>
						</TableContainer>
					}
				</VerticalBox>
			)}
		/>
	);
};
